// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + "23dadffd" + ".chunk.js");